export default {
  title: {
    weChatTemplateMessageManagementTitle: 'WeChat Message Management Template'
  },
  label: {
    weChatAccountIdLabel: 'WeChat Official Account (AppID)',
    weChatAccountKeyLabel: 'WeChat Official Account (AppKey)',
    weChatAccountTokenLabel: 'WeChat Official Account Webhook Token',
    weChatAccountPasswordLabel: 'WeChat Official Account Webhook Encoding Aes Key',
    weChatWebhook: 'WeChat Official Account Webhook URL',
    weChatAccountUrl: 'WeChat Official Account URL',
    weChatAccountUrlTip: 'Need help? Contact your AJINGA account manager.',
    weChatTemplateMessageTitle: 'WeChat Message Template',
    weChatTemplateMessageStatus: 'Status',
    createOrEditTemplateTitle: 'Create/Edit the WeChat Message Template by completing the information below.',
    createOrEditTemplateIdLabel: 'Template ID',
    createOrEditTemplateContentTitle: 'You can enter in the following dynamic placeholders at the start and end of your message:',
    createOrEditTemplateFieldTitle: '{{ Candidate Name }}，{{ Company Name }}，{{ Job Name }}',
    createOrEditTemplateFieldContent: 'Content',
    createOrEditTemplatePreview: 'Content Preview',
    selectTemplateField: 'Click the button to add WeChat template parameters',
    inputCustomField: 'WeChat Parameter Value. E.g. thing3',
    customTemplateTypeFieldLabel: 'Please input content',
    customTemplateTypeFieldValue: 'Custom:',
    verifyFile: 'WeChat JS Interface Security Domain Name Verification File'
  },
  placeholder: {
    verifyFile: 'Please choose file'
  },
  btn: {
    selectFile: 'Choose File'
  },
  tip: {
    appIdError: 'AppID cannot be empty.',
    appSecretError: 'AppKey cannot be empty.',
    createOrUpdateAppAccount: 'Bind WeChat Account',
    mustNeedTemplateId: 'Must need wechat template id',
    invalidAppId: 'Please check again',
    invalidAppSecret: 'Please check again'
  },
  message: {
    confirmCreateAppAccountTitle: 'Are you sure to bind this WeChat official account?',
    confirmUpdateAppAccountTitle: 'Are you sure you want to change the bound WeChat public account? Changing the official account will delete the binding information between the user and the original official account, and the WeChat message template will be invalidated and need to be reconfigured.',
    updateAppAccountSuccess: 'Successfully update company WeChat account info ',
    createAppAccountSuccess: 'Successfully create company WeChat Account info ',
    invalidAppId: 'Invalid WeChat account info, please check the AppID and AppKey',
    verifyFileSize: 'File size can not exceed {size} KB'
  }
}
